module.exports = "<svg id=\"cf4dae49-d808-4016-a79c-4376ecbf22ae\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-5 -5 55 55\"><title>quotes</title><path d=\"M12.08,7.73a12,12,0,1,0,0,23.91h.32c2.51-.15-6,12.46-5.81,12.28C21.45,38.09,24,23.42,24,19.68A12,12,0,0,0,12.08,7.73Z\"></path><path d=\"M37.92,7.73a12,12,0,1,0,0,23.91h.32c2.51-.15-6,12.46-5.81,12.28,14.86-5.81,17.44-20.49,17.44-24.23A12,12,0,0,0,37.92,7.73Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/quotes.svg
// module id = 3GQY
// module chunks = 2